import { createAction } from '@reduxjs/toolkit';

export const sendTargetadsTransactionAction = createAction(
  'SEND_TARGETADS_TRANSACTION',
);

export const sendTargetadsPageviewAction = createAction(
  'SEND_TARGETADS_PAGEVIEW',
);
